function updateCarouselItems(state, items) {
    state.carouselItems = items
}

function emptyCarouselItems(state, slot) {
    state.carouselItems.find(i => i.id === slot).article = null
}

function useCarouselItems(state, data) {
    state.carouselItems.find(s => s.id === data.slot).article = data.article
}

export default {
    updateCarouselItems,
    emptyCarouselItems,
    useCarouselItems
}
